<template>
    <div class="landing-page-finance container pt-5">
        <b-row class="text-center my-5">
            <b-col>
                <p class="get-mortgage-title">
                    Get a Mortgage
                </p>
            </b-col>
        </b-row>

        <b-row
                v-if="loading"
                class="loader-wrapper"
        >
            <b-col>
                <element-loader :loading="loading" />
            </b-col>
        </b-row>

        <b-row v-if="!loading">
            <b-col>
                <select-provider-step
                        v-if="financeAppResource.hasMultipleLenders && !loading"
                        class="ml-auto mr-auto"
                        :service-providers="serviceProviders"
                        :resource="mortgageResource"
                        hide-header
                        hide-footer
                        @connect="handleConnect"
                />

                <single-lender-card
                        v-else
                        class="mx-auto mb-5"
                        :finance-app-resource="financeAppResource"
                        :landing-page="landingPage"
                />
            </b-col>
        </b-row>

        <b-row
                v-if="!loading"
                class="text-center"
                :class="{
                'mt-5': isMobile || ! financeAppResource.hasMultipleLenders,
            }"
        >
            <b-col>
                <p class="text mb-5">
                    There are many mortgage lending options available. You are free to shop around to determine
                    that you are receiving the best services and <br v-if="!isMobile"> rates available.
                    The information above is provided for your reference, without warranty of any kind.
                </p>
            </b-col>
        </b-row>

        <get-connected-modal
                :source="serviceProvidersGetConnectedSource"
                skip-select
        />
    </div>
</template>

<script>
    import './Finance.scss';
    import ShowNotificationMixin from '@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin';
    import LandingPageFinanceSectionAppResource
        from '@milestoneslabs/milestones-core-js/src/AppResources/LandingPageFinanceSectionAppResource';
    import AppResourceSearch from '@milestoneslabs/milestones-js-engine/src/Data/AppResourceSearch';
    import ApiFilter from '@milestoneslabs/milestones-js-engine/src/Api/ApiFilter';
    import SingleLenderCard from "../../../components/LandingPage/Finance/SingleLenderCard/SingleLenderCard";
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
    import FormErrorsMixin from "@milestoneslabs/milestones-ui-kit/src/components/FormErrors/FormErrorsMixin";
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
    import AppResourceCollection from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceCollection";
    import ResourceAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/ResourceAppResource";
    import ServiceProviderAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/ServiceProviderAppResource";
    import SelectProviderStep
        from "@milestoneslabs/milestones-ui-kit/src/components/ServiceProviders/GetConnected/SelectProviderStep/SelectProviderStep";
    import GetConnectedModal, {
        GET_CONNECTED_WITH_SERVICE_PROVIDER_SHOW,
        LANDING_PAGE_SOURCE
    } from "@milestoneslabs/milestones-ui-kit/src/components/ServiceProviders/GetConnected/GetConnectedModal/GetConnectedModal";

    export default {
        name: 'Finance',
        components: {
            SingleLenderCard,
            SelectProviderStep,
            GetConnectedModal,
        },
        mixins: [
            ShowNotificationMixin,
            FormErrorsMixin,
            IsMobileMixin,
        ],

        props: {
            landingPage: {
                type: LandingPageAppResource,
                required: true,
            },
            serviceProviderList: {
                type: String,
                required: true,
            },
            mortgageResource: {
                type: ResourceAppResource,
                required: true,
            },
        },

        data() {
            return {
                loading: true,
                financeAppResource: new LandingPageFinanceSectionAppResource({}),
                serviceProviders: new AppResourceCollection('service-provider'),
                serviceProvider: new ServiceProviderAppResource({}),
                serviceProvidersGetConnectedSource: LANDING_PAGE_SOURCE,
            };
        },

        methods: {
            async fetchFinanceSection() {
                if (!this.landingPage.uuid) {
                    return;
                }

                try {
                    let search = new AppResourceSearch('landing-page-finance-section');
                    await search.setSearchData({
                        filter: new ApiFilter({
                            params: {
                                landingPageUuid: this.landingPage.uuid
                            }
                        })
                    }, false);

                    await search.search();

                    if (search.appResourceCollection.isNotEmpty) {
                        this.financeAppResource = search.appResourceCollection.getFirst();
                    }
                } catch (e) {
                    console.error(e);
                    this.showNotification({
                        message: `Something went wrong while fetching finance section. Please, try again later.`,
                        type: 'error',
                    });
                }
            },

            async fetchServiceProviders() {
                this.loading = true;
                try {
                    const serviceProvider = new ServiceProviderAppResource({});
                    const response = await serviceProvider.searchLandingPageServiceProviders({
                        serviceProviderListUuid: this.serviceProviderList,
                        serviceProviderTypeUuid: this.mortgageResource.serviceProviderTypeUuid,
                        landingPageUuid: this.landingPage.uuid,
                    });

                    serviceProvider.once('loaded', () => {
                        this.serviceProviders = response.appResourceCollection;
                        this.loading = false;
                    });
                } catch (e) {
                    console.error(e);
                    this.showNotification({
                        type: 'error',
                        message: 'Something went wrong. Please, try again later.',
                    });
                }
            },

            handleConnect(serviceProvider) {
                this.serviceProvider = serviceProvider;

                this.$uiBus.$emit(GET_CONNECTED_WITH_SERVICE_PROVIDER_SHOW, {
                    resource: this.mortgageResource,
                    serviceProvider: this.serviceProvider,
                    landingPage: this.landingPage,
                });
            },
        },

        async beforeMount() {
            await this.fetchFinanceSection();
            // temporary disable service provider fetch
            if (this.financeAppResource.hasMultipleLenders) {
                // await this.fetchServiceProviders();
            }

            this.loading = false;
        }
    };
</script>
